import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  const classes = inputs.filter(Boolean).map(i => {
    if (typeof i === 'object' && !Array.isArray(i) && i !== null) {
      return Object.keys(i).filter(k => i[k]).join(' ');
    }
    return i;
  }).join(' ');
  return twMerge(classes);
}
